import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import { Tab } from "@mui/material";
import { Group } from "./Group";
import { Panel } from "./Panel";
import { useTab } from "./tabContext";
import { Tabs } from "./Tabs";
const StyledTab = styled(Tab)(({ style, size }) => ({
    padding: "0 !important",
    minHeight: "30px",
    display: "flex",
    justifyContent: "start",
    borderBottom: `1px solid ${palette.grey025}`,
    color: palette.grey060,
    ...typography["Content.Subtitle04"],
    ...(size === "medium" && {
        ...typography["Content.Title04"],
    }),
    ...style,
}));
export const GrTab = ({ children, ...props }) => {
    const { color } = useTab();
    return _jsx(StyledTab, { ...props, label: children, color: color, disableRipple: true });
};
GrTab.Group = Group;
GrTab.Tabs = Tabs;
GrTab.Panel = Panel;
//# sourceMappingURL=GrTab.js.map